import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface PageModel<T> {
    items: T[];
    pageIndex?: number | null;
    pageSize?: number | null;
    total?: number | null;
}

export enum DoctorPreferenceSource {
    DashboardFromInsert = 0,
    ImportExcel = 1,
    FromWebUi = 2,
    SyncByDesignLabService = 3,
    DefaultReference = 4,
}

export interface DoctorPreference {
    id: string;
    doctorId: string;
    treatmentTypeId: number;
    designPreference: string;
    translation: string;
    createdDate: Date | string;
    modifiedDate: Date | string;
    createdBy?: string | null;
    source: DoctorPreferenceSource;
}

export interface OfficeOption {
    id: string;
    name: string;
}

export const createDoctorPreferenceEditForm = () =>
    new FormGroup({
        translation: new FormControl<string | null>({ disabled: false, value: null }, Validators.required),
        designPreference: new FormControl<string | null>({ value: null, disabled: false }),
    });

export type DoctorPreferenceEditForm = ReturnType<typeof createDoctorPreferenceEditForm>;
export type DoctorPreferenceEditModel = DoctorPreferenceEditForm['value'];
